import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { DayBudgetValue } from '../../typings/budget';
import { EditableCell } from '../EditableCell/EditableCell';
import { MoneyText } from '../MoneyText/MoneyText';

import './CampaignDayBudgetInfo.css';
import * as keyset from './CampaignDayBudgetInfo.i18n';

const i18n = i18nFactory(keyset);

export interface CampaignDayBudgetInfoBaseProps {
    value?: DayBudgetValue;
    isCompactViewEnabled: boolean;
}

export interface SimpleCampaignDayBudgetInfoProps
    extends CampaignDayBudgetInfoBaseProps {
    editable?: false;
}

export interface EditableCampaignDayBudgetInfoProps
    extends CampaignDayBudgetInfoBaseProps {
    onClick: () => void;
    isActive: boolean;
    editable: true;
}

export type CampaignDayBudgetInfoProps =
    | SimpleCampaignDayBudgetInfoProps
    | EditableCampaignDayBudgetInfoProps;

const BLOCK = 'campaign-day-budget-info';

export class CampaignDayBudgetInfo extends React.PureComponent<
    CampaignDayBudgetInfoProps
> {
    render() {
        const { value, isCompactViewEnabled } = this.props;

        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    mods: { compact: isCompactViewEnabled }
                })}
            >
                <p className={Bem.cls(BLOCK, 'value')}>
                    {this.getValueContent()}
                </p>
                {value && value.isActive ? (
                    <p className={Bem.cls(BLOCK, 'hint')}>{i18n('perDay')}</p>
                ) : null}
            </div>
        );
    }

    private getValueContent = () => {
        const { value } = this.props;

        const valueContent =
            value && value.isActive ? (
                <MoneyText num={value.sum} fractionalPartLength={2} />
            ) : (
                i18n('isNotSet')
            );

        return this.props.editable ? (
            <EditableCell
                onClick={this.props.onClick}
                isActive={this.props.isActive}
            >
                {valueContent}
            </EditableCell>
        ) : (
            valueContent
        );
    };
}
